import { render, staticRenderFns } from "./Namirnice.vue?vue&type=template&id=6a108d6a&scoped=true"
import script from "./Namirnice.vue?vue&type=script&lang=js"
export * from "./Namirnice.vue?vue&type=script&lang=js"
import style0 from "./Namirnice.vue?vue&type=style&index=0&id=6a108d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a108d6a",
  null
  
)

export default component.exports